// COPY de apps/desktop/src/...; dedup em F13 via packages/shared-ui.
import type { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  variant?: 'neutral' | 'accent' | 'success' | 'warning' | 'danger';
}

export function Badge({ children, variant = 'neutral' }: BadgeProps) {
  return (
    <span className="ds-badge" data-variant={variant}>
      {children}
    </span>
  );
}
